<template>
  <div name="snackbars">
    <v-snackbar
      v-model="show"
      :color="type"
      content-class="quanticy-snackbar"
      :timeout="timeout"
    >
      <div class="prepend-icon">
        <v-icon>{{ snackbarIcon }}</v-icon>
      </div>

      <slot>
        {{ text }}
      </slot>

      <template #action="{ attrs }">
        <v-btn
          :link="''"
          v-bind="attrs"
          text
          @click="show = false"
        >
          OK
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>

export default {
  name: 'Snackbar',
  data() {
    return {
      show: false,
      type: 'info',
      text: '',
      timeout: '0'
    };
  },
  computed: {
    snackbarIcon() {
      switch (this.type) {
      case 'success':
        return 'fa-check-circle';
      case 'error':
        return 'fa-exclamation-circle';
      case 'warning':
        return 'fa-exclamation-triangle';
      case 'info':
        return 'fa-info-circle';
      default:
        break;
      }
      return '';
    }
  },
  created() {
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'showSnackbar') {
        this.text = state.snackbar.text;
        this.type = state.snackbar.type;
        this.timeout = state.snackbar.timeout;
        this.show = true;
      }
    });
  }
};
</script>

<style lang="scss">
.v-snack .v-snack__wrapper{
  margin-bottom: 75px;

  & .v-snack__action .v-btn{
    margin-left: 5px;
    font-family: unset;

    font-weight: 500;
    font-size: 18px;
    line-height: 20px;

    letter-spacing: 0.03em;

    color: #fff;
  }

  & .v-snack__content.quanticy-snackbar {

    width: 100%;
    height: 57px;

    padding: 0;

    display: flex;
    flex-direction: row;
    align-items: center;

    gap: 20px;

    font-family: unset;
    font-size: 18px;
    line-height: 25px;


    & .prepend-icon {
      height: 100%;

      background: #ffffff1a;

      display: grid;
      place-items: center;

      & .v-icon {

        padding: 0 15px 0 20px;

        & .v-icon__component {
          width: 25px;
          height: 25px;
        }
      }

    }
  }
}
</style>
